import React, { useState } from "react";
import "./Contact.css";

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

const { $, grecaptcha } = window;

function Contact() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(
    "Bonjour,\n\nVeuillez me tenir informé des nouvelles fonctionnalités et mises à jour de Chiesugu.\n\nMerci !"
  );
  const [notification, setNotification] = useState("");
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setMessage(
      "Bonjour,\n\nVeuillez me tenir informé des nouvelles fonctionnalités et mises à jour de Chiesugu.\n\nMerci !"
    );
    setHasError(false);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setNotification("");

    // Vérification basique côté client
    if (!email || !message) {
      setHasError(true);
      setNotification("Veuillez remplir tous les champs obligatoires.");
      setLoading(false);
      return;
    }

    // Vérification du format email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setHasError(true);
      setNotification("Veuillez saisir une adresse email valide.");
      setLoading(false);
      return;
    }

    // Vérification de la longueur du message
    if (message.trim().length < 10) {
      setHasError(true);
      setNotification("Votre message doit contenir au moins 10 caractères.");
      setLoading(false);
      return;
    }

    grecaptcha.ready(function () {
      grecaptcha
        .execute(RECAPTCHA_KEY, { action: "submit" })
        .then(async function (token) {
          console.log(token);

          let data = {
            contact: {
              firstName,
              lastName,
              email,
              message,
              subject: "[Chiesugu] New Contact",
            },
            captcha: token,
          };

          try {
            let res = await fetch("/api/data/contact", {
              headers: {
                "Content-Type": "application/json",
              },
              method: "POST",
              body: JSON.stringify(data),
            });
            let response = await res.json();
            console.log("response", response);

            if (res.status !== 200) {
              throw new Error(JSON.stringify(response));
            } else {
              setHasError(false);
              setNotification(
                "Merci pour votre message ! Nous vous répondrons dans les plus brefs délais."
              );
              resetForm();
            }
          } catch (error) {
            console.log("error", error);
            setHasError(true);
            setNotification(
              "Une erreur est survenue lors de l'envoi de votre message. Veuillez réessayer plus tard."
            );
          } finally {
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log("reCAPTCHA error", error);
          setHasError(true);
          setNotification("Erreur de vérification. Veuillez réessayer.");
          setLoading(false);
        });
    });
  };
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact__content">
          <div className="contact__header">
            <h2 className="contact__title">
              Restons en <span className="text-primary">contact</span>
            </h2>
            <p className="contact__subtitle">
              Laissez-nous votre contact, nous vous tiendrons informé dès qu'il
              y aura du nouveau dans <strong>Chiesugu</strong>
            </p>
          </div>

          <div className="contact__form-container">
            <form className="contact__form" onSubmit={onSubmit}>
              <div className="contact__form-grid">
                <div className="contact__form-group">
                  <label htmlFor="firstName" className="contact__label">
                    Prénom <span className="contact__required">*</span>
                  </label>
                  <input
                    id="firstName"
                    className="contact__input"
                    type="text"
                    placeholder="Votre prénom"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    aria-describedby="firstName-help"
                    autoComplete="given-name"
                    required
                  />
                  <small id="firstName-help" className="contact__help-text">
                    Obligatoire - pour une réponse personnalisée
                  </small>
                </div>

                <div className="contact__form-group">
                  <label htmlFor="lastName" className="contact__label">
                    Nom de famille <span className="contact__required">*</span>
                  </label>
                  <input
                    id="lastName"
                    className="contact__input"
                    type="text"
                    placeholder="Votre nom de famille"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    aria-describedby="lastName-help"
                    autoComplete="family-name"
                    required
                  />
                  <small id="lastName-help" className="contact__help-text">
                    Obligatoire - pour une réponse personnalisée
                  </small>
                </div>

                <div className="contact__form-group contact__form-group--full">
                  <label htmlFor="email" className="contact__label">
                    Email <span className="contact__required">*</span>
                  </label>
                  <input
                    id="email"
                    className="contact__input"
                    type="email"
                    placeholder="votre@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    aria-describedby="email-help"
                    autoComplete="email"
                    required
                  />
                  <small id="email-help" className="contact__help-text">
                    Nous vous répondrons à cette adresse
                  </small>
                </div>

                <div className="contact__form-group contact__form-group--full">
                  <label htmlFor="message" className="contact__label">
                    Message <span className="contact__required">*</span>
                  </label>
                  <textarea
                    id="message"
                    className="contact__textarea"
                    rows="5"
                    placeholder="Dites-nous ce que vous pensez de Chiesugu, posez vos questions ou partagez vos suggestions..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    aria-describedby="message-help"
                    required
                  />
                  <small id="message-help" className="contact__help-text">
                    Minimum 10 caractères
                  </small>
                </div>

                <div className="contact__form-group contact__form-group--full">
                  <button
                    className={`btn btn--primary btn--large contact__submit ${
                      loading ? "contact__submit--loading" : ""
                    }`}
                    disabled={loading}
                    type="submit"
                  >
                    {loading ? (
                      <>
                        <span className="contact__spinner"></span>
                        Envoi en cours...
                      </>
                    ) : (
                      "Envoyer le message"
                    )}
                  </button>
                </div>

                {Boolean(notification) && (
                  <div
                    className={`contact__notification ${
                      hasError
                        ? "contact__notification--error"
                        : "contact__notification--success"
                    }`}
                  >
                    <div className="contact__notification-icon">
                      {hasError ? "⚠️" : "✅"}
                    </div>
                    <div className="contact__notification-content">
                      {notification}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
